var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rx-filter-loading',{attrs:{"loading":_vm.loading}}),_c('on-search',{attrs:{"miniComponent":true,"showStore":true},on:{"change":function($event){return _vm.onSearch($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }